module.exports = "pegasus/assets/themelp1/small/140.png";